// special case for CreditAccountNumber, which should be after DebitAccountNumber in whole system, really wanted by Honza (DEV-34040)
export const moveCreditAccountAfterDebit = (group: { id: string }[]): void => {
    const creditItems = group.filter(item => item.id.includes("CreditAccount"));

    creditItems.forEach(creditItem => {
        const creditIndex = group.findIndex(item => item.id === creditItem.id);
        const debitId = creditItem.id.replace("CreditAccount", "DebitAccount");
        const debitIndex = group.findIndex(item => item.id === debitId);

        if (debitIndex !== -1 && creditIndex !== -1 && creditIndex !== debitIndex + 1) {
            group.splice(creditIndex, 1);
            group.splice(debitIndex + 1, 0, creditItem);
        }
    });
};